var map = {
	"./1.png": 5967,
	"./10.png": 7439,
	"./11.png": 3638,
	"./12.png": 5405,
	"./2.png": 852,
	"./3.png": 1981,
	"./4.png": 258,
	"./5.png": 763,
	"./6.png": 592,
	"./7.png": 6841,
	"./8.png": 3806,
	"./9.png": 6951
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5326;